import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from './AuthProvider';
import { ForbiddenPage, NotFoundPage } from '../pages/NotFoundPage';
import { useFeatures, type FeatureKey } from '../features/settings/api';

export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') {
    return (
      <div className="auth-screen">
        <Spin size="large" />
      </div>
    );
  }
  if (status === 'anonymous') return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return <Outlet />;
}

export function RequireSuperAdmin() {
  const { user } = useAuth();
  if (user?.role !== 'SUPER_ADMIN') return <ForbiddenPage />;
  return <Outlet />;
}

/** Pages of a feature switched off in Settings → Features answer like an unknown address. */
export function RequireFeature({ feature }: { feature: FeatureKey }) {
  const features = useFeatures();
  if (!features.ready) return null;
  if (!features.enabled(feature)) return <NotFoundPage />;
  return <Outlet />;
}
